<template>
    <div class="pages">
        <div class="header">
            <div class="header-title">
                <p>{{ pageTitle.cn }}</p><p>{{ pageTitle.en }}</p>
            </div>
        </div>
        <div class="container">
            <p class="hasInput">必填项</p>
            <van-form @submit="onSubmit">
                <van-cell-group inset class="cell-group">
                    <van-field
                        v-model="postData.consigner"
                        name="consigner"
                        placeholder="委托人"
                        :rules="[{ required: true, message: '请填写委托人' }]"
                    />
                </van-cell-group>
                <van-cell-group inset class="cell-group">
                    <van-field
                        v-model="postData.consignerIdCard"
                        name="consignerIdCard"
                        placeholder="委托人身份证号"
                        :rules="[{ required: true, message: '请填写委托人身份证号' }]"
                    />
                </van-cell-group>
                <van-cell-group inset class="cell-group">
                    <van-field name="uploader">
                        <template #input>
                            <van-uploader
                                max-count="1"
                                upload-text="上传身份证正面"
                                :upload-icon="IDCardIconFront"
                                :after-read="handleUploadImageFront"
                                v-model="IDCardImgFront"
                            ></van-uploader>
                            <van-uploader
                                max-count="1"
                                upload-text="上传身份证反面"
                                :upload-icon="IDCardIconBack"
                                :after-read="handleUploadImageBack"
                                v-model="IDCardImgBack"
                            ></van-uploader>
                            <p class="upload-tip"><van-icon name="info" />证件文字需清晰辨认，格式JPG，小于5M,无遮挡或模糊。</p>
                        </template>
                    </van-field>
                </van-cell-group>
                <van-cell-group inset class="cell-group cell-group-eSign" @click="eSignVisible = true">
                    <p>委托人签字</p>
                    <img :src="eSignImgSrc" v-show="eSignImgSrc">
                </van-cell-group>
                <van-cell-group inset class="cell-group">
                    <van-field
                        v-model="postData.mandatarius"
                        name="mandatarius"
                        placeholder="受委托人"
                        :rules="[{ required: true, message: '请填写委托人' }]"
                    />
                </van-cell-group>
                <van-cell-group inset class="cell-group">
                    <van-field
                        v-model="postData.mandatariusIdCard"
                        name="mandatariusIdCard"
                        placeholder="受委托人身份证号"
                        :rules="[{ required: true, message: '请填写受委托人身份证号' }]"
                    />
                </van-cell-group>
                <van-cell-group inset class="cell-group">
                    <van-field
                        v-model="postData.mandatariusPhone"
                        name="mandatariusPhone"
                        placeholder="受委托人电话"
                        :rules="[{ required: true, message: '请填写受委托人电话' }]"
                    />
                </van-cell-group>
                <van-cell-group inset class="cell-group">
                    <van-field name="uploader" :rules="[{ required: true, message: '请选择身份证照片' }]">
                        <template #input>
                            <van-uploader
                                max-count="1"
                                upload-text="上传身份证正面"
                                :upload-icon="IDCardIconFront"
                                :after-read="handleUploadImageFrontFor"
                                v-model="IDCardImgFrontFor"
                            ></van-uploader>
                            <van-uploader
                                max-count="1"
                                upload-text="上传身份证反面"
                                :upload-icon="IDCardIconBack"
                                :after-read="handleUploadImageBackFor"
                                v-model="IDCardImgBackFor"
                            ></van-uploader>
                            <p class="upload-tip"><van-icon name="info" />证件文字需清晰辨认，格式JPG，小于5M,无遮挡或模糊。</p>
                        </template>
                    </van-field>
                </van-cell-group>
                <van-cell-group inset class="cell-group cell-group-eSign" @click="eSignVisibleFor = true">
                    <p>受委托人签字</p>
                    <img :src="eSignImgSrcFor" v-show="eSignImgSrcFor">
                </van-cell-group>
                <div style="margin: 16px;">
                    <van-button round block type="primary" native-type="submit">
                        提交
                    </van-button>
                </div>
            </van-form>
        </div>
        <eSign
            v-if="eSignVisible"
            @close="() => {eSignVisible = false}"
            @autographConfirm="eSignConfirm"
        ></eSign>
        <eSign
            v-if="eSignVisibleFor"
            @close="() => {eSignVisibleFor = false}"
            @autographConfirm="eSignConfirmFor"
        ></eSign>
    </div>
</template>

<script>
import { Form, Field, CellGroup, Button, Picker,Popup, Uploader,Icon } from 'vant'
import 'vant/es/button/style'
import 'vant/es/form/style'
import 'vant/es/field/style'
import 'vant/es/cell-group/style'
import 'vant/es/picker/style'
import 'vant/es/popup/style'
import 'vant/es/uploader/style'
import 'vant/es/icon/style'
import { ref } from 'vue'
import {notification} from "ant-design-vue"
const IDCardIconFront = require('@/assets/img/IDcard_front.png')
const IDCardIconBack = require('@/assets/img/IDcard_back.png')
import {uploadImageApi, uploadSignatureApi} from "@/api/directories"
import {savePowerOfAttorneyApi} from "@/api/townCenter"
import eSign from "../../../../components/townCenter/eSign"
import router from "@/router"
export default {
    name: "shouquanweituoshu",
    setup() {
        const pageTitle = {
            cn: '我要贷款',
            en: 'Loan Application'
        }
        const postData = ref({
            consigner: '',
            consignerIdCard: '',
            mandatarius: '',
            mandatariusIdCard: '',
            mandatariusPhone: '',
        })
        // 选择乡镇开始
        const townName = ref('');
        const showPicker = ref(false);
        const columns = ['杭州', '宁波', '温州', '嘉兴', '湖州']
        const onConfirm = (value) => {
            townName.value = value
            showPicker.value = false
        }
        // 选择乡镇结束
        // 上传委托人身份证正面
        const IDCardImgFront = ref([])
        const handleUploadImageFront = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    IDCardImgFront.value[0].id = res.bizId
                    IDCardImgFront.value[0].url = res.url.split('nyfile')[0] + res.url.split('nyfile')[1]
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                }
            }).catch(error => {
                console.error(error)
            })
        }
        // 上传委托人身份证反面
        const IDCardImgBack = ref([])
        const handleUploadImageBack = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    IDCardImgBack.value[0].id = res.bizId
                    IDCardImgBack.value[0].url = res.url.split('nyfile')[0] + res.url.split('nyfile')[1]
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                }
            }).catch(error => {
                console.error(error)
            })
        }
        // 上传受委托人身份证正面
        const IDCardImgFrontFor = ref([])
        const handleUploadImageFrontFor = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    IDCardImgFrontFor.value[0].id = res.bizId
                    IDCardImgFrontFor.value[0].url = res.url.split('nyfile')[0] + res.url.split('nyfile')[1]
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                }
            }).catch(error => {
                console.error(error)
            })
        }
        // 上传受委托人身份证反面
        const IDCardImgBackFor = ref([])
        const handleUploadImageBackFor = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    IDCardImgBackFor.value[0].id = res.bizId
                    IDCardImgBackFor.value[0].url = res.url.split('nyfile')[0] + res.url.split('nyfile')[1]
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                }
            }).catch(error => {
                console.error(error)
            })
        }

        // 上传委托人数字签名
        const eSignVisible = ref(false)
        const eSignImgSrc = ref('')
        let eSignUploadUrl = ''
        const eSignConfirm = (values) => {
            if (values.baseCode) {
                const img = values.baseCode.split('image/png;base64,')
                const fd = new FormData()
                fd.append('imgStr', img[1])
                uploadSignatureApi(fd).then(res => {
                    if (res) {
                        eSignUploadUrl = res.url.split('nyfile')[0] + res.url.split('nyfile')[1]
                        notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                    } else {
                        notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                    }
                }).catch(error => {
                    console.error(error)
                })
            }

            eSignImgSrc.value = values.baseCode
            eSignVisible.value = false
        }
        // 上传受委托人数字签名
        const eSignVisibleFor = ref(false)
        const eSignImgSrcFor = ref('')
        let eSignUploadUrlFor = ''
        const eSignConfirmFor = (values) => {
            if (values.baseCode) {
                const img = values.baseCode.split('image/png;base64,')
                const fd = new FormData()
                fd.append('imgStr', img[1])
                uploadSignatureApi(fd).then(res => {
                    if (res) {
                        eSignUploadUrlFor = res.url.split('nyfile')[0] + res.url.split('nyfile')[1]
                        notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                    } else {
                        notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                    }
                }).catch(error => {
                    console.error(error)
                })
            }
            eSignImgSrcFor.value = values.baseCode
            eSignVisibleFor.value = false
        }

        const onSubmit = (values) => {
            // console.log(IDCardImgFront.value[0].url)
            // console.log(IDCardImgBack.value[0].url)
            // console.log(IDCardImgFrontFor.value[0].url)
            // console.log(IDCardImgBackFor.value[0].url)
            // console.log(eSignImgSrc.value)
            // console.log(eSignImgSrcFor.value)
            if (!IDCardImgFront.value[0].url || !IDCardImgBack.value[0].url || !IDCardImgFrontFor.value[0].url || !IDCardImgBackFor.value[0].url || !eSignUploadUrl || !eSignUploadUrlFor) {
                notification.error({ message:  '请添加必要信息！', duration: 2.5, description: '' })
            }
            console.log('submit', values)
            const params = {
                consigner: values.consigner,
                consignerIdCard: values.consignerIdCard,
                consignerIdCardFrontImgUrl: IDCardImgFront.value[0].url,
                consignerIdCardReverseImgUrl: IDCardImgBack.value[0].url,
                consignerSignatureImgUrl: eSignUploadUrl,
                mandatarius: values.mandatarius,
                mandatariusIdCard: values.mandatariusIdCard,
                mandatariusIdCardFrontImgUrl: IDCardImgFrontFor.value[0].url,
                mandatariusIdCardReverseImgUrl: IDCardImgBackFor.value[0].url,
                mandatariusPhone: values.mandatariusPhone,
                mandatariusSignatureImgUrl: eSignUploadUrlFor,

            }
            savePowerOfAttorneyApi(params).then(res => {
                if (res) {
                    notification.success({ message:  '提交成功！', duration: 2.5, description: '' })
                    setTimeout(() => {
                        router.back(-1)
                    }, 2000)
                } else {
                    notification.error({ message: '提交失败！', duration: 2.5, description: '' })
                }
            })
        }
        return {
            pageTitle,
            postData,
            townName,
            columns,
            onConfirm,
            showPicker,
            IDCardIconFront,
            IDCardIconBack,
            handleUploadImageFront,
            handleUploadImageBack,
            IDCardImgFront,
            IDCardImgBack,
            eSignVisible,
            eSignImgSrc,
            eSignConfirm,
            onSubmit,
            handleUploadImageFrontFor,
            handleUploadImageBackFor,
            IDCardImgFrontFor,
            IDCardImgBackFor,
            eSignVisibleFor,
            eSignImgSrcFor,
            eSignConfirmFor,
        }
    },
    components: {
        [Form.name]: Form,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [Button.name]: Button,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [Uploader.name]: Uploader,
        [Icon.name]: Icon,
        eSign
    }
}
</script>

<style scoped lang="stylus">
.pages {
    width 100%
    height 100%
    background-color #F6F7FB
    .header {
        width 100%
        height 170px
        background-image url("../../../../assets/img/town_home_bg.png")
        background-repeat no-repeat
        background-size 100% 100%
        font-size 22px
        color #FFF
        display flex
        align-items center
        justify-content center
        .header-title {
            width 100%
            text-align center
        }
        .header-title p:last-child {
            font-size 12px
        }
    }
    .container {
        width 100%
        padding 16px 0
        background-color #F6F7FB
        .cell-group {
            margin-bottom 16px
        }
        .cell-group-eSign {
            padding 12px
            color #d3d3d6
        }
        .cell-group-eSign img {
            width 100%
        }
        .hasInput {
            font-size 14px
            color #1A1A1A
            margin-bottom 10px
            margin-left 20px
        }
        .hasInput:before {
            content '* '
            color #F05A24
        }
        .upload-tip {
            color #BEBCBC
            font-size 12px
        }

        /deep/ .van-field__control {
            display flex
            justify-content space-between
            flex-wrap wrap
            .van-uploader {
                width: 49%;
            }
        }
        /deep/ .van-uploader__upload,
        /deep/ .van-image,
        /deep/ .van-uploader__preview-image{
            width: 100%;
            height: 110px;
        }
        /deep/ .van-uploader__upload-text {
            margin-top: 8px;
            font-size: 12px;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 30px;
            line-height: 30px;
            background: #1da4f2;
            color: #fff;
            text-align: center;
        }
        /deep/ .van-uploader__upload,
        /deep/ .van-image{
            background: #E8F6FE;
            border-radius: 10px;
            overflow: hidden;
        }
        /deep/ .van-icon__image {
            width: 4em;
            height: 3em;
            -o-object-fit: contain;
            object-fit: contain;
            margin-bottom: 23px;
        }
    }
}
</style>
